import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { View } from '../layout/model/interfaces/view.interface';
import { SystemService } from '@shared/service/system/system.service';

@Injectable({ providedIn: 'root' })
export class TemplateUploadViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);
  private systemService = inject(SystemService);


  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const view = this.getView();
    if (view) {
      return await this.routeGuardService.handleRoute(view, route);
    }
    return true;
  }

  getView(): View {
    const projectName = this.systemService.getSelectedProject();
    const iframeUrl = projectName
      ? `upload_template?project=${projectName}`
      : 'upload_template';

    return {
      route: 'upload_template',
      iframeUrl,
    };
  }
}
